import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import './employerStyle.scss'

// SIGNIN CAROSEL FUNCTION 
const SignInCarosel=()=> {
  
//   const options = {
//     items: 1,
//     loop: true,
//     autoplay: true,
//     autoplayTimeout: 5000,
//     dots: true,
//     nav: false,
//   };
    return (
      <div className="signInCarousel">
        {/* <OwlCarousel {...options}> */}
            <div className="item">
                <div className="signInCarouselSet">
                    <img src={require('../../assets/images/work.png')} className="signInCarouselSetImg" alt=""/>
                    <span className="signInCarouselSetText">Extensive reach</span>
                </div>
                <div className="signInCarouselSet">
                    <img src={require('../../assets/images/categorie.png')} className="signInCarouselSetImg" alt=""/>
                    <span className="signInCarouselSetText">50+ categories</span>
                </div>
                <div className="signInCarouselSet">
                    <img src={require('../../assets/images/job-post.png')} className="signInCarouselSetImg" alt=""/>
                    <span className="signInCarouselSetText">User-friendly interface</span>
                </div>
                <div className="signInCarouselSet">
                    <img src={require('../../assets/images/card.png')} className="signInCarouselSetImg" alt=""/>
                    <span className="signInCarouselSetText">Secured payment method</span>
                </div>
                <div className="signInCarouselSet">
                    <img src={require('../../assets/images/user.png')} className="signInCarouselSetImg" alt=""/>
                    <span className="signInCarouselSetText">28,690+ Job searchers</span>
                </div>
                <div className="signInCarouselSet">
                    <img src={require('../../assets/images/real-time.png')} className="signInCarouselSetImg" alt=""/>
                    <span className="signInCarouselSetText">Real-time alerts</span>
                </div>
            </div>
  
      </div>
    )
}
export default SignInCarosel;